import { connect } from 'react-redux';
import * as R from 'ramda';

import Filters from './Filters';
import { getItem, setActiveState, setSearchField } from '../store/rackWaitTimesSlice';

const mapState = R.applySpec({
  activeState: getItem('activeState'),
  locationsPending: getItem('locationsPending'),
  searchField: getItem('searchField'),
  states: getItem('states'),
});

const mapDispatchToProps = {
  setActiveState,
  setSearchField,
};

export default connect(mapState, mapDispatchToProps)(Filters);
